import type { ReconciliationDocumentType } from '@/api/domains/reconciliation.types';
import { httpClient } from '@/shared/lib/axios';

import type { OrderSettingsColumnsResponse, OrderSettingsPayload, OrderSettingsResponse } from './order-settings.types';

export const OrderSettingsApi = {
  getColumns: async (documentType: ReconciliationDocumentType): Promise<OrderSettingsColumnsResponse> => {
    const { data } = await httpClient.get<OrderSettingsColumnsResponse>(`order-settings/${documentType}/columns`);

    return data;
  },

  getSettings: async (
    documentType: ReconciliationDocumentType,
    distributorId: number,
  ): Promise<OrderSettingsResponse> => {
    const { data } = await httpClient.get<OrderSettingsResponse>(
      `order-settings/${documentType}/${distributorId}/settings`,
    );

    return data;
  },

  saveSettings: async (
    documentType: ReconciliationDocumentType,
    distributorId: number,
    payload: OrderSettingsPayload,
  ) => {
    await httpClient.post(`order-settings/${documentType}/${distributorId}/settings`, payload);
  },
};
